<template>
<div class="reward-rules" ref="rewardbox">

    <div class="rule-title">
        <p @click="goback" class="back"></p>
        <img class="title" src="../assets/img/rulesimg/title.png" alt="">
    </div>
    <ul class="rules-list">
        <li class="rules-item">
            <p class="item-title">
                <img src="../assets/img/rulesimg/sort-1.png" alt="">
                <span>集赞赢奖励</span>
            </p>

            <p class="item-content">
                <span>即日起-**时间，转发视频并集赞，就有机会成为飞鹤品鉴之星，赢千元大奖</span>
                <ul class="table-box">
                    <li class="table-header">
                        <span>奖项名称</span>
                        <span>评选名额</span>
                        <span>奖励</span>
                    </li>
                    <li class="table-tbody">
                        <span>中国品鉴之星</span>
                        <span>点赞量排名前50名</span>
                        <span>价值5000元华为手机</span>
                    </li>
                    <li class="table-tbody">
                        <span>省级品鉴之星</span>
                        <span>点赞量排名第51名~300名</span>
                        <span>价值3000元华为平板电脑</span>
                    </li>
                    <li class="table-tbody">
                        <span>地区品鉴之星</span>
                        <span>点赞量排名第301~3000名</span>
                        <span>价值1000元美维士母婴营养大礼包</span>
                    </li>
                </ul>
            </p>
        </li>
        <li class="rules-item">
            <p class="item-title">
                <img src="../assets/img/rulesimg/sort-2.png" alt="">
                <span>活动流程说明</span>
            </p>
            <p class="item-content">
                <span>仅需3步，即可完成活动参与</span>
                <span>第一步：观看小视频并在为视频评论点赞</span>
                <span>第二步：点击PK赛按钮，使用手机号登录</span>
                <span>第三步：转发链接，引导好友观看视频并为视频评论点赞，即完成集赞，转发越多，集赞越多</span>
                <span class="reminder-title">温馨提示您：</span>
                <span class="reminder-item">①手机注册后才可记录集赞量</span>
                <span class="reminder-item">②点赞总量=微信朋友圈点赞量&评价量+微信群内转发获得的点赞量&评价量</span>
                <span class="reminder-item">③负面评价的点赞不计入点赞总量</span>
                <span class="reminder-item">④该活动仅限于微信内转发集赞，其他转发不计入参赛范围内</span>
            </p>
        </li>
        <li class="rules-item">
            <p class="item-title">
                <img src="../assets/img/rulesimg/sort-3.png" alt="">
                <span>奖励发放说明</span>
            </p>

            <p class="item-content">
                <span>活动结束后，由飞鹤消费者服务部联系消费者提供个人地址信息，将奖品邮寄到家。飞鹤全国服务热线电话：400-710-2768</span>
            </p>
        </li>
        <li class="rules-footer">
            <p class="notes">
                <span>注：</span>
                <span>所有评选经过正规公证机构全程跟踪、公证，星妈会（全站广告位、或首页轮播图位）公示中奖者微信号及手机号（滚动公示一个月），后台信息保留至兑现完毕</span>
            </p>
            <img src="../assets/img/rulesimg/rules-footer.png" alt="">
            <p class="footer-tip">解释权归飞鹤乳业有限公司</p>
        </li>
    </ul>

</div>
</template>

<script>
import {
    getJSSDK
} from "@/assets/utils/jssdk.js";

export default {
    name: "rewardRules",
    // created(){
    //   location.href.indexOf("active.feihe.com") >= 0 ? gio("init", "8a280edd3fe6d7e0", {}) : gio("init", "ac853984fcde2e20", {})
    //   gio('config', {'hashtag':true});
    //   gio("send");
    // },
    mounted() {
        window.onresize = () => {};
        window.ontouchmove="";
        getJSSDK(location.href.replace('#/rewardRules', ""));
    },
    methods: {
        goback() {
            this.$router.go(-1)
            // this.$router.replace({path:'/rankingList'});
        }
    }
}
</script>

<style lang="less" scoped>
.reward-rules {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 170px;
    background: url(../assets/img/rulesimg/rules-bg.png) no-repeat 0 0;
    background-size: cover;

    .rule-title {
        position: relative;
        width: 100%;
        height: 116px;
        padding: 38px 0 31px 0;
        text-align: center;

        .back {
            position: absolute;
            left: 26px;
            top: 42px;
            width: 31px;
            height: 47px;
            background: url(../assets/img/back.png) no-repeat 0 0;
            background-size: 100% 100%;
        }

        .title {
            width: 270px;
            height: auto;
        }

    }

    .rules-list {
        width: calc(100% - 76px);
        margin: 0 auto;
        padding: 62px 39px 88px 56px;
        background: #fff;
        border-radius: 20px;

        .rules-item {
            margin-bottom: 43px;

            .item-title {
                display: flex;
                align-items: center;
                height: 30px;
                margin-bottom: 22px;

                img {
                    display: block;
                    width: 28px;
                    height: 28px;
                    margin-right: 15px;
                }

                span {
                    display: block;
                    font-size: 28px;
                    font-weight: 500;
                    color: #3A3A3A;
                    line-height: 28px;
                }

            }

            .item-content {
                width: 100%;
                padding-left: 42px;

                >span {
                    display: block;
                    font-size: 24px;
                    font-weight: 400;
                    color: #626262;
                    line-height: 36px;
                    margin-bottom: 15px;
                }

                .table-box {
                    width: 100%;
                    border: 1px solid #B0B0B0;
                    border-radius: 6px;
                    overflow: hidden;

                    .table-header,
                    .table-tbody {
                        display: table;
                        width: 100%;

                        span {
                            width: calc(100% / 3);
                            display: table-cell;
                            text-align: center;
                            vertical-align: middle;

                            &:last-child {
                                border-right: none;
                                margin-right: -1px;
                            }
                        }

                    }

                    .table-header {
                        background: #FF9D13;
                        border-radius: 0px 6px 6px 0px;

                        span {
                            height: 100%;
                            font-size: 26px;
                            font-weight: 500;
                            color: #fff;
                            line-height: 74px;
                            border-right: 1px solid #fff;
                        }
                    }

                    .table-tbody {

                        span {

                            // height: 100%;
                            padding: 15px 20px;
                            font-size: 22px;
                            font-weight: 400;
                            color: #656565;
                            border-right: 1px solid #DBDBDB;
                            border-bottom: 1px solid #DBDBDB;
                        }

                        &:last-child {
                            span {
                                border-bottom: none;
                            }
                        }
                    }

                }

                .reminder-item {
                    padding-left: 12px;
                }

            }

        }

        .rules-footer {
            padding-left: 8px;

            .notes {
                display: flex;
                justify-content: space-around;

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #626262;
                    line-height: 36px;

                    &:first-child {
                        width: 36px;
                        margin-right: 19px;
                        font-size: 28px;
                        font-weight: 500;
                        color: #3A3A3A;
                    }
                }
            }

            img {
                width: calc(100% - 54px);
                height: auto;
                margin: 75px 0 49px 32px;
            }

            .footer-tip {
                text-align: center;
                font-size: 22px;
                font-weight: 400;
                color: #C5C5C5;
                line-height: 24px;
            }
        }
    }
}

// @media screen and (orientation: landscape){
//   .reward-rules{
//     overflow: auto;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/view/rewardRules.vue